import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import 'material-design-icons-iconfont/dist/material-design-icons.css' // Ensure you are using css-loader
import '@fortawesome/fontawesome-free/css/all.css'

Vue.use(Vuetify)

const theme = {
  primary: '#367FBF',
  secondary: '#89AF3F',
  accent: '#0F375B',
  info: '#01579B',
  success: "#1B5E20",
  warning: "#ffbf00"
}

export default new Vuetify({
  icons: {
    iconfont: ['fa'],
  },
  theme: {
    themes: {
      light: theme,
      dark: theme,
    },
  },
})